import React from 'react';
import CreateMealPlan from '../components/food/createMealPlan';
import {Header} from '../components/global/header';
import {Footer} from '../components/global/footer';

const CreateMealPlanPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <CreateMealPlan />
      <Footer />
    </div>
  );
};

export default CreateMealPlanPage;
